(() => {
  if (window.__ddcCartGuardLoaded) return;
  window.__ddcCartGuardLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ddc-clear-cart]');
    if (!button) return;
    if (!window.confirm('¿Quieres vaciar este pedido completo para elegir otro regalo?')) return;

    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Vaciando pedido…';
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

    try {
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      });
      const cart = await response.json().catch(() => null);
      if (!response.ok || !cart || Number(cart.item_count) !== 0) throw new Error();
      window.location.href = `${root}collections/desayunos-sorpresa`;
    } catch (_) {
      button.disabled = false;
      button.textContent = original;
      window.alert('No pudimos vaciar el pedido. Recarga la página e inténtalo de nuevo.');
    }
  });
})();
